import React from 'react';
import { useTranslation } from 'react-i18next';

import MediaTypography from 'components/MediaTypography';

import { checkRole } from '@common/components/RBAC';
import { IClientGradeBookModel } from '@common/models/ClientGradeBook/ClientGradeBook';

interface PropsType {
	gradeBook: IClientGradeBookModel;
}

function GradeBookLessonInfoComment({ gradeBook }: PropsType) {
	const { t } = useTranslation();

	const isUkrainianExternship = gradeBook.location_id === 10;
	const gradeComments = isUkrainianExternship
		? gradeBook.grades
				.filter((grade) => grade?.chunk?.chunk_type?.id === 5)
				.map((grade) => grade.comment)
				.filter((comment): comment is string => Boolean(comment))
		: [];

	const finalComments = [gradeBook.final_comment, ...gradeComments].filter(
		(comment): comment is string => Boolean(comment),
	);

	const mergedFinalComment = finalComments.join('');

	const isShownComment =
		Boolean(mergedFinalComment) && (checkRole('Parent') || gradeBook.is_show_final_comment);

	if (!isShownComment) return null;

	return (
		<MediaTypography color="#5F9257" variant="caption1">
			{t('gradeBook.teacherLeftComment')}
		</MediaTypography>
	);
}

export default GradeBookLessonInfoComment;
